import { render, staticRenderFns } from "./pod_report.vue?vue&type=template&id=066fbad5&"
import script from "./pod_report.vue?vue&type=script&lang=js&"
export * from "./pod_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports